import React, { Component } from 'react'
import { forEach, orderBy, map } from 'lodash'
import { connect } from 'react-redux'
import firebase from 'firebase/app'
import { Segment, Label, Button, Header, Icon } from 'semantic-ui-react'
import styled from 'styled-components'

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import AppCustomizationActions from '../../../../reducers/appCustomizationReducer'

const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: flex-end;
  width: 500px;
`

class ServicesArrangement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      displayServices: null,
      saving: false,
      hasArranged: false,
    }
  }

  componentDidMount() {
    const {
      servicesLoaded,
      categoriesLoaded,
      services,
      categories,
      getCustomization,
    } = this.props

    if (!categoriesLoaded) {
      getCustomization({
        screen: 'entry',
        resource: 'categories',
        orderBy: ['created_at', 'desc']
      })
    }

    if (!servicesLoaded) {
      getCustomization({
        screen: 'entry',
        resource: 'services',
        orderBy: ['order', 'asc']
      })
    }

    this.getDisplayServices(services, categories)
  }

  componentDidUpdate(prevProps) {
    const { services, categories } = this.props

    if (prevProps.services !== services || prevProps.categories !== categories) {
      this.getDisplayServices(services, categories)
    }
  }

  getDisplayServices = (services, categories) => {
    const displayServices = orderBy(Object.values(services), ['order'], ['asc'])
    const serviceKeys = Object.keys(services)

    forEach(categories, category => {
      if (!serviceKeys.includes(category.id)) displayServices.push(category)
    })

    this.setState({ displayServices })
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  }

  onDragEnd = result => {
    const { displayServices } = this.state
    const { source, destination } = result

    if (!destination) {
      return
    }

    const items = this.reorder(displayServices, source.index, destination.index)

    this.setState({
      displayServices: items,
      hasArranged: true,
    })
  }

  getListStyle = () => ({
    width: 500,
    borderRadius: 10,
  })

  getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: 15,
    margin: `4px 0 4px 0`,
    width: '100%',
    borderRadius: `5px`,
    background: isDragging ? 'black' : '#e0e1e2',
    color: isDragging ? 'white' : 'rgba(0,0,0,.8)',
    ...draggableStyle,
  })

  onReset = () => {
    const { services, categories } = this.props

    this.getDisplayServices(services, categories)
    this.setState({ hasArranged: false })
  }

  onSave = async () => {
    try {
      const { displayServices } = this.state
      const { setSingleCustomization } = this.props

      this.setState({ saving: true })
      const batch = firebase.firestore().batch()

      forEach(displayServices, (service, index) => {
        const doc = firebase
          .firestore()
          .collection('app_customization')
          .doc('entry')
          .collection('services')
          .doc(service.id)

        const isService = service.is_service || false

        const updates = {
          is_service: isService,
          title: service.title,
          order: index + 1
        }

        if (service.key) updates.key = service.key

        batch.set(doc, updates)
        setSingleCustomization({
          screen: 'entry',
          resource: 'services',
          data: { ...updates, id: service.id }
        })
      })

      await batch.commit()
    } catch (error) {
      alert('Failed to update arrangement')
    } finally {
      this.setState({ saving: false, hasArranged: false })
    }
  }

  onEdit = async service => {
    try {
      const { setSingleCustomization } = this.props

      const namePrompt = window.prompt('Change service name to: ')

      if (namePrompt) {
        const doc = firebase
          .firestore()
          .collection('app_customization')
          .doc('entry')
          .collection('services')
          .doc(service.id)

        await doc.update({ title: namePrompt })

        const newData = {
          ...service,
          title: namePrompt,
          id: service.id
        }

        setSingleCustomization({ screen: 'entry', resource: 'services', data: newData })
      }
    } catch (error) {
      alert('Failed to change service name')
    }
  }

  renderServices = () => {
    const { displayServices } = this.state

    return map(displayServices, (service, index) => {
      const key = service.id || service.key
      const isService = service.is_service

      return (
        <Draggable key={key} draggableId={key} index={index}>
          {(dragProvided, snapshot) => {
            return (
              <div
                ref={dragProvided.innerRef}
                {...dragProvided.draggableProps}
                {...dragProvided.dragHandleProps}
                style={this.getItemStyle(snapshot.isDragging, dragProvided.draggableProps.style)}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    flex: 1,
                  }}
                >
                  <div style={{ marginRight: 20 }}>
                    {service.order !== '' && (
                      <Label color="red" horizontal>
                        {service.order}
                      </Label>
                    )}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flex: 1,
                      flexDirection: 'column',
                      cursor: 'text'
                    }}
                  >
                    <div>{service.title}</div>
                  </div>

                  <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}></div>
                    <div>
                      {isService ?
                        <Icon
                          name="edit"
                          style={{ marginRight: 15, cursor: 'default' }}
                          onClick={() => this.onEdit(service)}
                        />
                      : null}
                    </div>
                    <div>
                      <Icon name="align justify" />
                    </div>
                  </div>
                </div>
              )
            }}
        </Draggable>
      )
    })
  }

  render() {
    const { hasArranged, saving } = this.state
    const { loading } = this.props

    return (
      <Segment color="black" loading={loading}>
        <Header content="Services" size="large" style={{ display: 'inline-block' }} />
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {dropProvided => (
              <div
                ref={dropProvided.innerRef}
                style={this.getListStyle()}
                className="droppable-services"
                {...dropProvided.droppableProps}
              >
                {this.renderServices()}
                {dropProvided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <ButtonWrapper>
          <Button icon="undo" content="Reset" onClick={this.onReset} disabled={!hasArranged} />
          <Button
            color="black"
            content="Save"
            loading={saving}
            disabled={saving || !hasArranged}
            onClick={this.onSave}
          />
        </ButtonWrapper>
      </Segment>
    )
  }
}

const mapState = ({ appCustomization: { entry } }) => ({
  categories: entry.categories.data,
  services: entry.services.data,
  loading: entry.categories.loading || entry.services.loading,
  categoriesLoaded: entry.categories.loaded,
  servicesLoaded: entry.services.loaded,
})

const mapDispatch = {
  getCustomization: AppCustomizationActions.getCustomization,

  removeSingleCustomization: AppCustomizationActions.removeSingleCustomization,
  setSingleCustomization: AppCustomizationActions.setSingleCustomization,
}

export default connect(
  mapState,
  mapDispatch
)(ServicesArrangement)


// WEBPACK FOOTER //
// ./src/containers/appCustomization/components/ServicesArrangement/index.js